import React from 'react'

const HeroCaro = () => {
    return (
        <div>

        </div>
    )
}

export default HeroCaro
